import { CellContext, createColumnHelper, Row } from "@tanstack/react-table";
import { TaskListLocalTabViewProps } from "./types/taskListLocalTabViewProps";
import TableActions from "../../../../components/shared/table/tableActions/tableActions";
import { HeadersTable } from "../../../../helpers/featureTableConstruct";
import { TableProps } from "../../../../components/shared/table/types/tableProps";
import Table from "../../../../components/shared/table/table";
import './taskListLocalTabView.scss'
import { ObjectType } from "../../../../contexts/types/card";
import { useContext, useEffect } from "react";
import PermissionsContext from "../../../../contexts/permissionsContext";
import { canBeEdited, canBeVerified, checkAssigment } from "../../../../helpers/permissionsHelper";
import ViewContext from "../../../../contexts/viewContext";
//import { ObjectState } from "../types/tasklListViewProps";
//import { apiContext } from "../../../../contexts/apiContext";
// import { UpdateProtocolStateProps } from "../../../../services/protocolFormService/types/protocolFormServiceProps";
// import { updateProtocolState } from "../../../../services/protocolFormService/protocolFormService";
import { TableContext } from "../../../../contexts/tableContext";
import AuthContext from "../../../../contexts/authContext";
// import SlideoutWrapper from "../../../../components/slideoutWrapper/slideoutWrapper";
// import WebMap from "../../../../components/webmap/webmap";
// import { SlideoutBtnPosition } from "../../../../components/slideoutWrapper/types/slideoutWrapperProps";
// import { ReactComponent as MapIcon } from '../../../../icons/map.svg';


const TaskListLocalTabView = (props: TaskListLocalTabViewProps) => {
    const { userRoles, username } = useContext(AuthContext);
    const { functionsPermissions, extendedUserPermissions } = useContext(PermissionsContext);
    const { setViewType, setViewData, viewTypes } = useContext(ViewContext);
    //const api = useContext(apiContext);
    const { setCheckboxesTable } = useContext(TableContext);

    useEffect(() => {
        setCheckboxesTable([]);
    }, [setCheckboxesTable])

    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType={"taskListLocal"} //properties.row.getValue('ObjectType')}
            editClickHandler={handleEditClick}
        />)
    }

    const handleEditClick = (row: any) => {
        var rowCorrect = {
            attributes: row
        }
        const waitingroom = rowCorrect.attributes;
        const objectType: ObjectType = waitingroom.RODZAJ_OBIEKTU;
        const objectStatus = waitingroom.STAN_OBIEKTU_DOM;
        var isKR = objectType === ObjectType.KRO || objectType === ObjectType.KRTZ;

        const assignedUser = waitingroom.PRZYPISANY_UZYTKOWNIK;
        const isAssigment = checkAssigment(username, assignedUser, userRoles);

        if (isAssigment && canBeEdited(functionsPermissions, waitingroom, extendedUserPermissions, undefined, true)) {
            if (isKR) {   
                setViewData({ row: rowCorrect, editMode: true, local: true});
                setViewType(viewTypes.KRForm);
            }
            else{
                setViewData({ row: rowCorrect, local: true});
                setViewType(viewTypes.POForm);
            }
        }else if (isAssigment && canBeVerified(functionsPermissions, objectStatus)) {
            if (isKR) { 
                setViewData({ row: rowCorrect, editMode: false, local: true});
                setViewType(viewTypes.KRForm);
            }
        }
    }

    var columns = Object.keys(props.headers).filter(item => item !== "TERYT" && item !== "SHAPE_YES_NO");

    const compareId = (row1: Row<any>, row2: Row<any>) => {
        if(!row1.original.attributes){
            row1.original.attributes = row1.original;
        }
        if(!row2.original.attributes){
            row2.original.attributes = row2.original;
        }
        return row1.original.attributes.NUMER_IDENTYFIKACYJNY === row2.original.attributes.NUMER_IDENTYFIKACYJNY &&
        row1.original.attributes.RODZAJ_OBIEKTU === row2.original.attributes.RODZAJ_OBIEKTU &&
        row1.original.attributes.GLOBALID === row2.original.attributes.GLOBALID;
    }

    var tableProps: TableProps = {
        columnAliases: props.headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: columns,
        cellActions: cellAction,
        loading: props.loading,
        data: props.data,
        columnConfig: props.columnConfig,
        extraSelection: props.extraSelection,
        selection: props.selection,
        compareId: compareId,
        firstColumnCheckbox: true,
        tableFiltersVisible: true,
        isPagination: props.isPagination,
        pagination: props.pagination,
        setPagination: props.setPagination,
        allCount: props.allCount,
        pageCount: props.pageCount,
        setPageCount: props.setPageCount,
        onPaginationChange: props.onPaginationChange,
        scrollable: true,
        threeDots: true,
        onTrClick: props.onTrClick,
        threeDotsProps: {
            menuItemClass: 'threeDotsMenuItem',
            editOnClick: props.threeDotsProps?.editOnClick,
            collectiveEditOnClick: props.threeDotsProps?.collectiveEditOnClick,
            table: props.threeDotsProps?.table,
            markStatus: props.threeDotsProps?.markStatus,
            automaticVerificationClick: props.threeDotsProps?.automaticVerificationClick,
            ReturnCardClick: props.threeDotsProps?.ReturnCardClick,
            validateOnClick: props.threeDotsProps?.validateOnClick
        }
    }
    
    return (<div className="TaskListLocalWaitingTabView">
        <Table {...tableProps} />
        {/* {functionsPermissions.showObjGeomOnMap.active &&
            <SlideoutWrapper icon={MapIcon} btnPos={SlideoutBtnPosition.Left}>
                <WebMap config={api.mapComposition.waitingRoom} baseMap={api.baseMap} />
            </SlideoutWrapper>
        } */}
    </div>);
}

export default TaskListLocalTabView;